import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Input, Button, CardBody, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FaWallet, FaGlobe, FaFile, FaShoppingCart, FaEye, FaEdit, FaArrowRight, FaFilter } from 'react-icons/fa';
import DataTable from 'react-data-table-component';
import { NavLink, useNavigate } from 'react-router-dom';
import DashboardService from "./dashboard.service.js";
import AuthService from "../Authentication/auth.service.js";
import { useTranslation } from 'react-i18next';
import DateRangePickerComponent from './DateRangePickerComponent.js'; // Adjust the import path as needed
import PermissionAccess from '../../PermissionAccess/Access.js';
import { Tooltip as Tooltips } from "@mui/material";
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Divider } from '@mui/material';
import DashboardTables from './DashboardTables.js';
import moment from "moment";
import styled from "styled-components";
import DiscountCouponService from "../DiscountCoupon/Discountcoupons.service.js";
import UpdateStatus from '../Order/UpdateStatus.js';
import UpdateStatusDoctor from '../Order/UpdateStatus.js';
import Alerts from "../../components/Alerts/alerts.js";
import Services from "../Quotations/services.js";

const Label = styled.label`
  display: block;
  font-weight: bold;
`;

const Loader = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;



const Home = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const sessionID = authData?.sessionID;
  const [selectedRevenue, setSelectedRevenue] = useState('TotalRevenue');
  const [selectedInterval, setSelectedInterval] = useState('Yearly');
  const [purchaseData, setPurchaseData] = useState([])
  const [totalPurchases, setTotalPurchases] = useState([])
  const [doctorPurchases, setDoctorPurchases] = useState([])
  const [customerPurchases, setCustomerPurchases] = useState([])
  const [showModalUpdateStatus, setshowModalUpdateStatus] = useState(false);
  const [showModalUpdateStatusDoctor, setshowModalUpdateStatusDoctor] = useState(false);
  const [array, setArray] = useState([]);
  const [arrayDoctor, setArrayDoctor] = useState([]);
  const [orders, setOrders] = useState([]);
  const [DoctorOrder, setDoctorOrder] = useState([])
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [DoctorPageLimit, setDoctorPageLimit] = useState(10);
  const [DoctorCurrentPage, setDoctorCurrentPage] = useState(0);
  const [DoctorTotalRows, setDoctorTotalRows] = useState(0);
  const [NewStatus, setNewStatus] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);


  const handleToggleModalUpdateStatus = (row) => {
    setArray(row);
    setshowModalUpdateStatus(!showModalUpdateStatus);
  }

  const handleToggleModalUpdateStatusDoctor = (row) => {
    setArrayDoctor(row);
    setshowModalUpdateStatusDoctor(!showModalUpdateStatusDoctor);
  }

  const [dashboardData, setDashboardData] = useState({
    trendData: [],
    latestRFQs: []
  });
  //iph todo: 47
  //console.log("sessionID", sessionID)
  useEffect(() => {
    if (sessionID === null || sessionID === undefined) {
      AuthService.logout();
      navigate("/login");
    } else {
      i18n.changeLanguage(localStorage.getItem('language'));
      fetchDashboardData();
      fetchRevenueData(selectedRevenue, selectedInterval)
    }
  }, []);

  useEffect(() => {
    if (sessionID === null || sessionID === undefined) {
      AuthService.logout();
      navigate("/login");
    } else {
      fetchOrders(currentPage, pageLimit);
      fetchNewStatus();
    }
  }, [pageLimit, i18n]);

  useEffect(() => {
    if (sessionID === null || sessionID === undefined) {
      AuthService.logout();
      navigate("/login");
    } else {
      fetchDoctorOrders(DoctorCurrentPage, pageLimit);
    }
  }, [DoctorPageLimit, i18n]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchNewStatus();
    fetchOrders(page, DoctorPageLimit);
  };

  const handlePerRowsChange = async (newLimit, page) => {
    setPageLimit(newLimit);
  };

  const handlePageChangeDoctor = (page) => {
    setCurrentPage(page);
    fetchDoctorOrders(page, pageLimit);
  };

  const handlePerRowsChangeDoctor = async (newLimit, page) => {
    setDoctorPageLimit(newLimit);
  };



  function fetchDoctorOrders(page_index, page_limit) {
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    const stored_user = authData?.userData;
    let business = []
    if (stored_user?.businesses) {
      business = stored_user?.businesses
    }
    var payload = {
      functionName: "GetAdminRFQs",
      postData: {
        filter: {},
        limit: page_limit,
        offset: offset,
        business: [],
        order_for: 'doctor'
      }
    }

    setLoading(true);
    Services.GetAdminRFQs(authData?.sessionID, payload).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Get Quotations response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        setDoctorOrder(response.data.data);
        //iph todo: 47
        //console.log("Responsse", response.data);
        setDoctorTotalRows(response.data.counts.count);
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };

  const fetchOrders = (page_index, page_limit) => {
    setLoading(true);
    const stored_user = authData?.userData;
    let businessIDs = []
    if (stored_user?.businesses) {
      businessIDs = stored_user?.businesses
    }
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }

    var payload = {
      functionName: "GetAdminRFQs",
      postData: {
        filter: {},
        limit: page_limit,
        offset: offset,
        business: [],
        order_for: 'customer'
      }
    }
    DiscountCouponService.GetAdminRFQs(authData?.sessionID, payload).then(
      (response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          setOrders(response.data.data);
          setTotalRows(response.data.counts.count);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        Alerts.swalErrorAlert(errContent || t("Server Error, Please try again later."));
      }
    );
  };

  const fetchNewStatus = () => {
    setLoading(true);
    const stored_user = authData?.userData;
    let businessIDs = []
    if (stored_user?.businesses) {
      businessIDs = stored_user?.businesses
    }
    var payload = {
      functionName: "GetNewStatus",
      postData: {
        filter: {},
        order_for: 'customer'
      }
    }
    DiscountCouponService.fetchNewStatus(authData?.sessionID, payload).then(
      (response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          //iph todo: 47
          //console.log("setNewStatus", response.data.data);
          setNewStatus(response.data.data);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        Alerts.swalErrorAlert(errContent || t("Server Error, Please try again later."));
      }
    );
  };

  const fetchDashboardData = async () => {
    setLoading(true);
    try {

      const response = await DashboardService.getAdminDashboardData(sessionID, startDate, endDate); // Pass dates
      if (response.data.status) {
        setDashboardData(response.data.data);
      } else {
        //iph todo: 47
        //console.error("Dashboard data retrieval failed.");
      }
    } catch (error) {
      if (error.response && error.response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
    } finally {
      setLoading(false);
    }
  };


  const fetchRevenueData = async (Type, interval) => {
    setSelectedRevenue(Type);
    setLoading(true);

    let endDate = new Date();
    let startDate = new Date(endDate);

    // Set startDate based on selected interval
    if (interval === 'Daily') {
      startDate.setDate(startDate.getDate() - 1);
    } else if (interval === 'Weekly') {
      startDate.setDate(startDate.getDate() - 6);
    } else if (interval === 'Monthly') {
      startDate.setMonth(startDate.getMonth() - 1);
    } else if (interval === 'Yearly') {
      startDate.setFullYear(startDate.getFullYear() - 1);
    }

    // Define label formats based on interval
    const formatLabels = (interval) => {
      let labels = [];
      const currentDate = new Date();

      if (interval === 'Daily') {
        labels.push(currentDate.toLocaleDateString());
      } else if (interval === 'Weekly') {
        for (let i = 6; i >= 0; i--) {
          const day = new Date();
          day.setDate(day.getDate() - i);
          labels.push(day.toLocaleDateString());
        }
      } else if (interval === 'Monthly') {
        const daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
        for (let i = 1; i <= daysInMonth; i++) {
          labels.push(`${currentDate.getMonth() + 1}/${i}`);
        }
      } else if (interval === 'Yearly') {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        labels = months;
      }
      return labels;
    };

    try {
      // API call with dynamic startDate and endDate
      const response = await DashboardService.getAdminRevenueData(Type, startDate, endDate, interval, sessionID);

      if (response.data.status) {
        let data = [];
        const labels = formatLabels(interval);

        if (Type === 'TotalRevenue') {
          const { doctorsData, ecommerceData } = response.data.data;

          // Map response data to labels
          data = labels.map((label, index) => ({
            name: label,
            doctors: doctorsData.find(item => item._id[interval === 'Yearly' ? 'month' : interval === 'Weekly' ? 'dayOfWeek' : 'day'] === index + 1)?.value || 0,
            ecommerce: ecommerceData.find(item => item._id[interval === 'Yearly' ? 'month' : interval === 'Weekly' ? 'dayOfWeek' : 'day'] === index + 1)?.value || 0
          }));
        } else {
          data = labels.map((label, index) => ({
            name: label,
            value: response.data.data.singleTypeData.find(item => item._id[interval === 'Yearly' ? 'month' : interval === 'Weekly' ? 'dayOfWeek' : 'day'] === index + 1)?.value || 0
          }));
        }

        setPurchaseData(data);
        setTotalPurchases(response.data.TotalPurchases);
        setDoctorPurchases(response.data.DoctorPurchases);
        setCustomerPurchases(response.data.CustomerPurchases);
      } else {
        //iph todo: 47
        //console.error("Data fetch failed:", response.data.message);
      }
    } catch (error) {
      console.log("Error fetching revenue data:", error);
      if (error.response && error.response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  };




  const handleIntervalChange = (interval) => {
    setSelectedInterval(interval);
    fetchRevenueData(selectedRevenue, interval);
  };

  const ViewDetails = (id) => {
    navigate(`/quotation_details`, { state: { id } });
  }


  const handleDateChange = async (startDate, endDate) => {
    setStartDate(startDate || null);
    setEndDate(endDate || null);
    setLoading(true);
    //iph todo: 47
    //console.log("Start startDate", startDate)
    //iph todo: 47
    //console.log("Start endDate", endDate)
    try {
      const response = await DashboardService.getAdminDashboardData(sessionID, startDate, endDate);
      if (response.data.status) {
        setDashboardData(response.data.data);
      } else {
        //iph todo: 47
        //console.error("Dashboard data retrieval failed.");
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      if (error.response && error.response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
    } finally {
      setLoading(false);
    }
  };




  const handleRowClick = (row) => {
    navigate(`/e-invoice-details/${row.id}`, { state: row });
  };


  const CustomerColumns = [
    {
      name: t('Customer Name'),
      selector: row => {
        const name = row?.userDetails?.[0]?.name || t('N/A');
        return `${name}`;
      },
      sortable: true,
    },
    {
      name: t('Order Number'),
      selector: row => {
        const name = row?.order_number || t('---');
        return `${name}`;
      },
      sortable: true,
    },
    {
      name: t('Order Date Time'),
      selector: "order_date",
      sortable: true,
      cell: row => moment(row?.order_date).format('DD-MM-YYYY hh:mm:ss A')
    },
    {
      name: t('Total Items'),
      selector: row => {
        return `${row?.items?.length}`;
      },
      sortable: true,
    },
    {
      name: t('Amount'),
      selector: row => {
        return `${row?.total}`;
      },
      sortable: true,
    },

    {
      name: t('Order Status'),
      selector: (row) => {
        const getButtonStyle = (status) => {
          switch (status) {
            case 'confirmed':
              return {
                borderColor: '#ffc107',
                backgroundColor: '#ffc107',
                color: '#000'
              };
            case 'processing':
              return {
                borderColor: '#007bff',
                backgroundColor: '#007bff',
                color: '#fff'
              };
            case 'in_transit':
            case 'picked_up':
              return {
                borderColor: '#6f42c1',
                backgroundColor: '#6f42c1',
                color: '#fff'
              };
            case 'cancelled':
              return {
                borderColor: '#dc3545',
                backgroundColor: '#dc3545',
                color: '#fff'
              };
            default:
              return {
                borderColor: '#28a745',
                backgroundColor: '#28a745',
                color: '#fff'
              };
          }
        };

        const formatStatus = (status) => {
          if (status.includes('*')) {
            // Remove asterisk and replace underscores with spaces
            return status.replace('*', '').replace(/_/g, ' ').toUpperCase();
          } else if (status === 'in_transit') {
            return 'IN TRANSIT';
          } else if (status === 'picked_up') {
            return 'PICKED UP';
          } else {
            return status.toUpperCase();
          }
        };

        const buttonStyle = getButtonStyle(row?.status);

        return (
          <div>
            <button
              type="button"
              style={buttonStyle}
              className={`btn btn-sm btn-hover-shine me-3 ${row?.status === 'confirmed' ? 'btn-success' : 'btn-danger'}`}
            >
              {formatStatus(row?.status)}
            </button>
          </div>
        );
      },
      sortable: true,
    },

    {
      name: t('Actions'),
      selector: (row) => {
        return (
          <div>
            {!super_admin ? current_module?.ViewData === 1 &&
              <NavLink to={`/order-details/${row?._id}`}><Tooltips placement="top" title={`${t("View")} ${t("Details")}`} arrow style={{ cursor: "pointer" }}>
                <i className="pe-7s-look text-primary btn-icon-wrapper text-primary fs-5 p-1"> </i>
              </Tooltips>
              </NavLink>
              :
              <NavLink to={`/order-details/${row?._id}`}>
                <Tooltips placement="top" title={`${t("View")} ${t("Details")}`} arrow style={{ cursor: "pointer" }}>
                  <i className="pe-7s-look text-primary btn-icon-wrapper text-primary fs-5 p-1"> </i>
                </Tooltips>
              </NavLink>
            }

            {row?.status.toLowerCase() !== "delivered" && (
              !super_admin ? current_module?.EditData === 1 &&
                <Tooltips placement="top" title={`${t("Update")} ${t("Status")}`} arrow>
                  <i
                    className="pe-7s-pen btn-icon-wrapper text-primary fs-5 p-1"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleModalUpdateStatus(row)}
                  > </i>
                </Tooltips>

                :
                <Tooltips placement="top" title={`${t("Update")} ${t("Status")}`} arrow>
                  <i
                    className="pe-7s-pen btn-icon-wrapper text-primary fs-5 p-1"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleModalUpdateStatus(row)}
                  > </i>
                </Tooltips>
            )}

          </div>
        );
      }
    }
  ];

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return '#FFA500'; // Orange
      case 'confirmed':
        return 'green'; // green
      case 'accepted':
        return '#4169E1'; // Royal Blue
      case 'processing':
        return '#9370DB'; // Medium Purple
      case 'in_transit':
        return '#1E90FF'; // Dodger Blue
      case 'delivered':
        return '#32CD32'; // Lime Green
      case 'cancelled':
      case 'rejected':
        return '#DC143C'; // Crimson
      case 'issued':
        return '#228B22'; // Forest Green
      case 'review':
        return '#FF4500'; // Orange Red
      default:
        return '#808080'; // Gray for unknown status
    }
  };
  const DoctorColumns = [
    { name: 'Order ID', selector: row => row?.order_number ? row?.order_number : row?.rfq_id, sortable: true },
    { name: 'Doctor Name', selector: row => row?.userDetails?.[0]?.name, sortable: true },
    { name: 'Date of Order', selector: row => moment(row?.datetime_added).format('DD-MM-YYYY'), sortable: true },
    { name: 'Quotation Date', selector: row => row?.quotation_date ? moment(row?.quotation_date).format('DD-MM-YYYY') : 'N/A', sortable: true },
    { name: 'Total Item', selector: row => row?.items?.length, sortable: true },
    {
      name: 'Status',
      selector: row => row?.status.charAt(0).toUpperCase() + row?.status.slice(1),
      sortable: true,
      cell: row => {
        const capitalizedStatus = row?.status.charAt(0).toUpperCase() + row?.status.slice(1);
        return (
          <span style={{
            color: getStatusColor(row?.status),
            fontWeight: 'bold',
          }}>
            {capitalizedStatus}
          </span>
        );
      }
    },
    {
      name: t("Actions"),
      selector: (row) => {
        return (
          <div>
            <button className="mt-2 mb-2 me-2 btn-icon btn">
              {(super_admin || current_module?.ViewData === 1) && (
                <Tooltips title={t("View Details")}>
                  <i onClick={() => ViewDetails(row?._id)} className="pe-7s-note2 btn-icon-wrapper text-primary"> </i>
                </Tooltips>
              )}
              {/* {(super_admin || current_module?.chat === 1) && (
                <Tooltips title={t("Chat")}>
                  <button className="btn btn-link p-0" onClick={() => navigate(`/chat_admin/${row?._id}`)}>
                    <i className="pe-7s-chat text-success" style={{ fontSize: '1.2rem' }}></i>
                  </button>
                </Tooltips>
              )} */}
              {row?.return_status === 'pending' && (super_admin || current_module?.chat === 1) && row?.status.toLowerCase() === "delivered" && (
                <Tooltips title={t("Return Items")}>
                  <button className="btn btn-link p-0" onClick={() => navigate(`/return_items_admin/${row._id}`)} >
                    <i className="pe-7s-refresh text-success" style={{ fontSize: '1.2rem' }}></i>
                  </button>
                </Tooltips>
              )}
              {row?.status.toLowerCase() !== "delivered" && row?.status.toLowerCase() !== "requested" && row?.status.toLowerCase() !== "Review" && (
                !super_admin ? current_module?.EditData === 1 &&
                  <Tooltips placement="top" title={`${t("Update")} ${t("Status")}`} arrow>
                    <i
                      className="pe-7s-pen btn-icon-wrapper text-primary fs-5 p-1"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleToggleModalUpdateStatusDoctor(row)}
                    > </i>
                  </Tooltips>

                  :
                  <Tooltips placement="top" title={`${t("Update")} ${t("Status")}`} arrow>
                    <i
                      className="pe-7s-pen btn-icon-wrapper text-primary fs-5 p-1"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleToggleModalUpdateStatusDoctor(row)}
                    > </i>
                  </Tooltips>
              )}
            </button>
          </div>
        );
      }
    }
  ]

  return (
    <div className="app-main__outer">
      <div className="container mt-4">
        <div className="app-page-title">
          <div className="page-title-wrapper">
            <div className="page-title-heading fw-bold">
              <div className="page-title-icon">
                <i className="pe-7s-news-paper icon-gradient bg-tempting-azure" />
              </div>
              <div>
                {`${t("Dashboard")}`}
              </div>
            </div>
          </div>
        </div>

        <UpdateStatusDoctor
          showModalUpdateStatusDoctor={showModalUpdateStatusDoctor}
          handleToggleModalUpdateStatusDoctor={handleToggleModalUpdateStatusDoctor}
          onSuccess={fetchDoctorOrders}
          array={arrayDoctor}
        />

        <UpdateStatus
          showModalUpdateStatus={showModalUpdateStatus}
          handleToggleModalUpdateStatus={handleToggleModalUpdateStatus}
          onSuccess={fetchOrders}
          array={array}
        />

        <Row className="g-4 mb-2">
          <div className="d-flex justify-content-end align-items-center gap-2 mb-2">
            <span className="text-secondary">Filter</span>
            <DateRangePickerComponent onDateChange={handleDateChange} />
          </div>
        </Row>


        <Row className="g-4 mb-4">
          {dashboardData.trendData.map((trend, index) => (
            <Col md={4} key={index}>
              <Card body className="trend-card d-flex flex-row align-items-center justify-content-between">
                <div>
                  <div className="trend-title">{trend.title}</div>
                  <div className="trend-value">{trend.value}</div>
                </div>
                <div className="icon-circle" style={{ backgroundColor: '#3D607A' }}>
                  {trend.title.includes('Total') ? <FaWallet /> :
                    trend.title.includes('Pending') ? <FaGlobe /> :
                      trend.title.includes('Processed') ? <FaFile /> :
                        <FaShoppingCart />}
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        <Row className="g-4 mt">
          <Card body className="order-card">
            <Row className="g-4">
              <Col md={4}>
                <Card
                  style={{
                    cursor: 'pointer',
                    backgroundColor: selectedRevenue === 'TotalRevenue' ? "#3488A4" : 'white',
                    color: selectedRevenue === 'TotalRevenue' ? 'white' : 'black'
                  }}
                  onClick={() => { fetchRevenueData('TotalRevenue', selectedInterval) }}
                  body className="trend-card d-flex flex-row align-items-center justify-content-between cursor-pointer">
                  <div>
                    <div style={{
                      fontSize: "14px",
                      color: selectedRevenue === 'TotalRevenue' ? 'white' : 'black',
                      marginBottom: "2px",
                    }}>{"Full Revenue"}</div>
                    <div style={{
                      fontSize: "14px",
                      fontWeight: "600px",
                      color: selectedRevenue === 'TotalRevenue' ? 'white' : 'black',
                    }}>
                      {'RM '}{parseFloat(totalPurchases).toFixed(2)}
                    </div>
                  </div>
                  <div className="icon-circle" style={{ backgroundColor: '#3D607A' }}>
                    <FaArrowRight />
                  </div>
                </Card>
                <Card
                  style={{
                    cursor: 'pointer',
                    backgroundColor: selectedRevenue === 'DoctorsPortal' ? "#3488A4" : 'white',
                    color: selectedRevenue === 'DoctorsPortal' ? 'white' : 'black'
                  }}
                  onClick={() => { fetchRevenueData('DoctorsPortal', selectedInterval) }}
                  body className="trend-card d-flex flex-row align-items-center justify-content-between cursor-pointer">
                  <div>
                    <div style={{
                      fontSize: "14px",
                      color: selectedRevenue === 'DoctorsPortal' ? 'white' : 'black',
                      marginBottom: "2px",
                    }}>{"Doctor's Portal"}</div>
                    <div style={{
                      fontSize: "14px",
                      fontWeight: "600px",
                      color: selectedRevenue === 'DoctorsPortal' ? 'white' : 'black',
                    }}>
                      {'RM '}{parseFloat(doctorPurchases).toFixed(2)}
                    </div>
                  </div>
                  <div className="icon-circle" style={{ backgroundColor: '#3D607A' }}>
                    <FaArrowRight />
                  </div>
                </Card>
                <Card
                  style={{
                    cursor: 'pointer',
                    backgroundColor: selectedRevenue === 'ECommerceShop' ? "#3488A4" : 'white',
                    color: selectedRevenue === 'ECommerceShop' ? 'white' : 'black'

                  }}
                  onClick={() => { fetchRevenueData('ECommerceShop', selectedInterval) }}
                  body className="trend-card d-flex flex-row align-items-center justify-content-between cursor-pointer">
                  <div>
                    <div style={{
                      fontSize: "14px",
                      color: selectedRevenue === 'ECommerceShop' ? 'white' : 'black',
                      marginBottom: "2px",
                    }}>{"eCommerce Shop"}</div>
                    <div style={{
                      fontSize: "14px",
                      fontWeight: "600px",
                      color: selectedRevenue === 'ECommerceShop' ? 'white' : 'black',
                    }}>
                      {'RM '}{parseFloat(customerPurchases).toFixed(2)}
                    </div>
                  </div>
                  <div className="icon-circle" style={{ backgroundColor: '#3D607A' }}>
                    <FaArrowRight />
                  </div>
                </Card>
              </Col>
              <Col md={8}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="m-0">{selectedRevenue === 'TotalRevenue' ? 'Full Revenue' : selectedRevenue === 'DoctorsPortal' ? "Doctor's Portal" : 'eCommerce Shop'}</h5>

                  <div className="d-flex align-items-center">
                    {selectedRevenue === 'TotalRevenue' ?
                      <>
                        <div style={{
                          marginLeft: '2px',
                          width: '20px',
                          height: '20px',
                          backgroundColor: '#0E77D3',
                          borderRadius: '50%',
                          display: 'inline-block'
                        }}></div>
                        <h6 className="m-0">{"Doctor's Portal"}</h6>
                        <div style={{
                          marginLeft: '5px',
                          marginRight: '5px',
                          width: '20px',
                          height: '20px',
                          backgroundColor: '#3C6082',
                          borderRadius: '50%',
                          display: 'inline-block'
                        }}></div>
                        <h6 className="m-0">{"eCommerce Shop"}</h6>
                      </>
                      :
                      selectedRevenue === 'DoctorsPortal' ?
                        <>
                          <div style={{
                            marginLeft: '2px',
                            width: '20px',
                            height: '20px',
                            backgroundColor: '#0E77D3',
                            borderRadius: '50%',
                            display: 'inline-block'
                          }}></div>
                          <h6 className="m-0">{"Doctor's Portal"}</h6>
                        </>
                        :
                        <>
                          <div style={{
                            marginLeft: '5px',
                            marginRight: '5px',
                            width: '20px',
                            height: '20px',
                            backgroundColor: '#3C6082',
                            borderRadius: '50%',
                            display: 'inline-block'
                          }}></div>
                          <h6 className="m-0">{"eCommerce Shop"}</h6>
                        </>
                    }
                    <h6 style={{ marginTop: '10px', marginLeft: '10px', marginRight: '5px' }}>Sort by</h6>
                    <UncontrolledDropdown className="me-2 d-inline-block ml-2">
                      <DropdownToggle caret color="light">
                        {selectedInterval} <FaFilter size={14} />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => handleIntervalChange('Daily')}>Daily</DropdownItem>
                        <DropdownItem onClick={() => handleIntervalChange('Weekly')}>Weekly</DropdownItem>
                        <DropdownItem onClick={() => handleIntervalChange('Monthly')}>Monthly</DropdownItem>
                        <DropdownItem onClick={() => handleIntervalChange('Yearly')}>Yearly</DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>

                  </div>
                </div>
                <div style={{ width: '100%', height: '400px' }}>
                  {loading ? (
                    <Loader />
                  ) : (
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={purchaseData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        {selectedRevenue === 'TotalRevenue' ? (
                          <>
                            <Bar dataKey="doctors" fill="#0E77D3" name="Doctor's Portal" />
                            <Bar dataKey="ecommerce" fill="#3C6082" name="eCommerce Shop" />
                          </>
                        ) : (
                          <Bar dataKey="value" fill="#3488A4" />
                        )}
                      </BarChart>
                    </ResponsiveContainer>
                  )}
                </div>
              </Col>
            </Row>
          </Card>
          <DashboardTables
            doctorsData={DoctorOrder}
            ecommerceData={orders}
            handlePageChangeDoctor={handlePageChangeDoctor}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            handlePerRowsChangeDoctor={handlePerRowsChangeDoctor}
            totalRows={totalRows}
            NewStatus={NewStatus}
            DoctorTotalRows={DoctorTotalRows}
            CustomerColumns={CustomerColumns}
            DoctorColumns={DoctorColumns}
            header="Payment Status"
            sort={false}
            add={false}
          />
        </Row>

        <style>{`
        .trend-card {
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          background-color: #ffffff;
        }
        .icon-circle {
          width: 40px;
          height: 40px;
          border-radius: 25%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }
        .trend-title {
          font-size: 14px;
          color: #777;
          margin-bottom: 2px;
        }
        .trend-value {
          font-size: 18px;
          font-weight: 600;
          color: #333;
        }
        .chart-card, .order-card {
          height: 500px;
          overflow: hidden;
        }
        .order-list {
          max-height: 250px;
          overflow-y: auto;
        }
        .vertical-divider {
          border-left: 1px solid #ccc;
          height: 100px; 
          margin: 0 10px; 
        }        
      `}</style>
      </div>
    </div >
  );
};

export default Home;

{/* <div className="vertical-divider"></div> */ }
